import React from "react";

export default function OptionRow({ checked, disabled, label, onToggle }) {
  return (
    <label className={`survey-option${checked ? " checked" : ""}${disabled ? " disabled" : ""}`}>
      <input
        checked={checked}
        disabled={disabled}
        onChange={onToggle}
        type="checkbox"
      />
      <span>{label}</span>
    </label>
  );
}
